import { render, staticRenderFns } from "./CardFixScaleNP.vue?vue&type=template&id=61c4e121"
import script from "./CardFixScaleNP.vue?vue&type=script&lang=js"
export * from "./CardFixScaleNP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports